var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5664_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.862 134.011C502.175 111.592 481.047 90.0942 458.941 87.2142C324.172 70.4651 187.847 70.4651 53.0773 87.2142C30.9531 90.088 9.82519 111.592 7.13763 134.011C-2.3788 216.177 -2.3788 295.844 7.13763 377.991C9.82519 400.41 30.9531 421.928 53.0773 424.788C187.847 441.537 324.172 441.537 458.941 424.788C481.047 421.933 502.175 400.41 504.862 377.991C514.38 295.852 514.38 216.177 504.862 134.011ZM213.33 341.35V170.678L341.333 256.017L213.33 341.35Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5664_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a56083584e5fda98fe26efe506b811f5.svg";
export { ForwardRef as ReactComponent };